export const CANVAS_PAPER_OPTIONS = [
  { id: '8x10', label: '8x10', price: 12.95 },
  { id: '8x12', label: '8x12', price: 14.95 },
  { id: '10x12', label: '10x12', price: 18.95 },
  { id: '11x14', label: '11x14', price: 19.95 },
  { id: '12x16-18', label: '12x16/18', price: 24.95 },
  { id: '16x20-24', label: '16x20/24', price: 39.95 },
  { id: '20x24', label: '20x24', price: 59.95 },
  { id: '20x30', label: '20x30', price: 69.95 },
  { id: '24x30', label: '24x30', price: 75.00 },
  { id: '24x36', label: '24x36', price: 85.00 },
  { id: '30x40', label: '30x40', price: 140.00 },
  { id: '40x60', label: '40x60', price: 230.00 }
];

export const PAPER_SIZE_OPTIONS = [
  { id: 'a4', label: 'A4' },
  { id: 'a3', label: 'A3' },
  { id: 'a2', label: 'A2' },
  { id: 'a1', label: 'A1' },
  { id: 'a0', label: 'A0' }
];

export const PAPER_TYPE_OPTIONS = [
  { id: 'lustre', label: 'Lustre 300 GSM / Light Art Paper and Canvas' },
  { id: 'entrada', label: 'Entrada Cotton Natural Rag 290 GSM' }
];

export const PAPER_PRICE_TABLE = {
  a4: { lustre: 15.00, entrada: 30.00 },
  a3: { lustre: 25.00, entrada: 50.00 },
  a2: { lustre: 45.00, entrada: 90.00 },
  a1: { lustre: 85.00, entrada: 170.00 },
  a0: { lustre: 160.00, entrada: 320.00 }
};

export const getPaperPrice = (paperSize, paperType) => {
  return PAPER_PRICE_TABLE[paperSize]?.[paperType] || 0;
};

export function PaperSize({ value, onChange }) {
  return (
    <select className="form-select" value={value} onChange={onChange}>
      <option value="">Select paper size</option>
      {PAPER_SIZE_OPTIONS.map((option) => (
        <option key={option.id} value={option.id}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

export function PaperType({ value, onChange }) {
  return (
    <select className="form-select" value={value} onChange={onChange}>
      <option value="">Select paper type</option>
      {PAPER_TYPE_OPTIONS.map((option) => (
        <option key={option.id} value={option.id}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

function Paper({ value, onChange }) {
  return (
    <select className="form-select" value={value} onChange={onChange}>
      <option value="">Select paper size</option>
      {CANVAS_PAPER_OPTIONS.map((option) => (
        <option key={option.id} value={option.id}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

export default Paper;
